import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import Packing_Checklist_Corp from '../../../modal/Production_Management/Manage_Packing/Packing_Checklist_Corp';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import DeliveryCorp from '../../../modal/Production_Management/Manage_Packing/DeliveryCorp';
import { toast } from 'react-toastify';
import axios from 'axios';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Manage_Packing = () => {

    const tableRef = useRef(null);
    const [key, setKey] = useState('corporate_packing');
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [orders, setOrders] = useState([]);
    const [selectedPackingCatModelData, setPackingCatModelData] = useState([]);
    const [selectedDeliveryCatModelData, setDeliveryCatModelData] = useState([]);

    const [hasFetched, setHasFetched] = useState(false);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const onClose = () => {
        setFilterOpen(false);
    };


    const handleModalToggleChecklistCat = (order) => {
        setModalType("Packing_Checklist_Corp");
        setPackingCatModelData(order);
        setOpen(true);
    };


    const handleModalToggleDeliveryCat = (order) => {
        setModalType("DeliveryCorp");
        setDeliveryCatModelData(order);
        setOpen(true);
    };


    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    "pageLength": 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const fetchOrders = async (filters = {}) => {
        try {
            const params = { branch_id, ...filters };
            const response = await axios.get(`${BaseUrl}/corp-packing-list`, { params });
            const data = response.data.data;
            setOrders(Array.isArray(data) ? data : []);
        } catch (error) {
            setOrders([]);
            toast.error('Failed to fetch orders');
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchOrders();
    };

    const formatDateSend = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0]; // "YYYY-MM-DD"
    };

    const handleGoClick = () => {
        const filter = {
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = formatDateSend(custom_stdt_fil_value) || '';
            filter.end_date = formatDateSend(custom_eddt_fil_value) || '';
        } else if (date_fil_selt_value === 'this_week') {
            filter.start_date = formatDateSend(week_stdt_fil_value) || '';
            filter.end_date = formatDateSend(week_eddt_fil_value) || '';
        } else if (date_fil_selt_value === 'this_month') {
            const month = month_fil_value.getMonth() + 1; // 1-12
            const year = month_fil_value.getFullYear();
            filter.month = month;
            filter.year = year;
        } else if (date_fil_selt_value === 'today') {
            filter.date = formatDateSend(today_fil_value) || '';
        }

        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchOrders(filter);
        onClose();
    };

    const formatDispatchedDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        const formatted = date
            .toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            })
            .replace(",", ""); // remove comma between date & time

        // Convert "03 Dec 2025 12:22 PM" → "03-Dec-2025 12:22 PM"
        const [day, month, year, time, meridiem] = formatted.split(" ");
        return `${day}-${month}-${year} ${time} ${meridiem}`;
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Packing</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>
                {open && modalType === "Packing_Checklist_Corp" && (
                    <Packing_Checklist_Corp show={open} onClose={() => {setOpen(false); fetchOrders();}} order={selectedPackingCatModelData} />
                )}

                {open && modalType === "DeliveryCorp" && (
                    <DeliveryCorp show={open} onClose={() => {setOpen(false); fetchOrders();}} order={selectedDeliveryCatModelData} />
                )}
                <div className='d-flex align-items-center justify-content-center flex-row gap-2'>
                    {/* <label className='fs-5 text-danger font-w600'>
                        {new Date().toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                        })}
                    </label> */}
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                </div>
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-packing">
                                    <i className="fa-solid fa-money-bill-trend-up me-2"></i>
                                    <label className="fs-6">
                                        Subscription
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-packing-catering">
                                    <i className="fa-solid fa-layer-group me-2"></i>
                                    <label className="fs-6">
                                        Catering Order
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="corporate_packing" >
                                    <i className="fa-solid fa-hotel me-2"></i>
                                    <label className="fs-6">
                                        Corporate Order
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">

                            <Tab.Pane eventKey="corporate_packing">
                                <Row>

                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className="min-w-100px text-start">Customer / Mobile No</th>
                                                        <th className="min-w-100px text-start">Order Id/Delivery Date</th>
                                                        <th className="min-w-80px">Ready / Total Items</th>
                                                        <th className="min-w-80px">Status</th>
                                                        <th className="min-w-80px text-end">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {orders.map((order) => (
                                                        <tr key={order?.sno}>
                                                            <td>
                                                                <div className="d-flex flex-column align-items-start">
                                                                    <label className="text-black font-w400 fs-7">
                                                                        {order?.customer_name}
                                                                    </label>
                                                                    <label className="text-dark font-w400 fs-7">
                                                                        {order?.customer_number}
                                                                    </label>
                                                                </div>
                                                            </td>

                                                            <td className="text-center">
                                                                <div className="d-flex flex-column align-items-start">
                                                                    <Badge bg="warning" className="text-black rounded font-w500 fs-7">
                                                                        {order?.order_id}
                                                                    </Badge>
                                                                    <label className="text-primary font-w500 fs-7">
                                                                        {formatDate(order?.packing_date)}
                                                                    </label>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="d-flex flex-row align-items-center justify-content-start gap-1">
                                                                    {/* Ready Items */}
                                                                    <label className="text-danger rounded border border-danger py-1 px-2 font-w700 fs-7">
                                                                        {order?.packed_item_count || 0}
                                                                    </label>

                                                                    <label className="text-black font-w400 fs-7">|</label>

                                                                    {/* Total Items */}
                                                                    <label className="text-primary rounded border border-primary py-1 px-2 font-w700 fs-7">
                                                                        {order.total_packing_count ? order.total_packing_count : 0}
                                                                    </label>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {order?.packing_status == 0 && (
                                                                    <Badge bg="warning" className="text-white rounded font-w500 fs-7">
                                                                        Yet to Pack
                                                                    </Badge>
                                                                )}
                                                                {order?.packing_status == 1 && (
                                                                    <Badge bg="info" className="text-white rounded font-w500 fs-7">
                                                                        Packing
                                                                    </Badge>
                                                                )}
                                                                {order?.packing_status == 2 && (
                                                                    <Badge bg="success" className="text-white rounded font-w500 fs-7">
                                                                        Packed
                                                                    </Badge>
                                                                )}
                                                                {order?.packing_status == 3 && (
                                                                    <div className="d-flex flex-column align-items-start">
                                                                        <Badge bg="primary" className="text-white rounded font-w500 fs-7">
                                                                            Dispatched
                                                                        </Badge>
                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip className="toltip-popover">
                                                                                    <span className="fs-8 text-white fw-semibold">Dispatched Time</span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <label className="text-danger font-w500 fs-7">
                                                                                {order?formatDispatchedDate(order.dispatched_time): ''}
                                                                            </label>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td className="text-end">
                                                                <OverlayTrigger
                                                                    trigger={['hover', 'focus']}
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="toltip-popover">
                                                                            <span className="fs-8 text-white fw-semibold">View</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <Link to={`/view-corporate-packing?data=${order?.sno}`}>
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                                            <span>
                                                                                <i className="fa-solid fa-eye fs-6 mt-1"></i>
                                                                            </span>
                                                                        </Button>
                                                                    </Link>
                                                                </OverlayTrigger>

                                                                {(order?.packing_status === 0 || order?.packing_status === 1) && (
                                                                    <OverlayTrigger
                                                                        trigger={['hover', 'focus']}
                                                                        placement="bottom"
                                                                        overlay={
                                                                            <Tooltip className="toltip-popover">
                                                                                <span className="fs-8 text-white fw-semibold">Packing Checklist</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <Button
                                                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                                                            onClick={() => handleModalToggleChecklistCat(order)}
                                                                        >
                                                                            <span>
                                                                                <i className="fa-solid fa-box-archive fs-6 mt-1"></i>
                                                                            </span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                )}

                                                                {(order?.packing_status == 2) && (
                                                                    <OverlayTrigger
                                                                        trigger={['hover', 'focus']}
                                                                        placement="bottom"
                                                                        overlay={
                                                                            <Tooltip className="toltip-popover">
                                                                                <span className="fs-8 text-white fw-semibold">Move to Delivery</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <Button
                                                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                                                            onClick={() => handleModalToggleDeliveryCat(order)}
                                                                        >
                                                                            <span>
                                                                                <i className="fa-solid fa-truck-arrow-right fs-6 mt-1"></i>
                                                                            </span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                    </Col>

                                </Row>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Manage Packing Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
                            setDateFilSeltValue('all');
                            softRefresh();
                            setPage(1);
                            setPerPage(25);
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default Manage_Packing;